module.exports = __webpack_public_path__ + "static/media/EmptyState.40789615.svg";